var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRowGrave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3722_24095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3722_24095)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 24,
    r: 6,
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 14L67.7321 17H64.2679L66 14Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 34L64.2679 31L67.7321 31L66 34Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 24L73 25.7321L73 22.2679L76 24Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 24L59 22.2679L59 25.7321L56 24Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0711 31.0714L69.7251 30.1749L72.1746 27.7254L73.0711 31.0714Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9289 16.9286L62.2749 17.8251L59.8254 20.2746L58.9289 16.9286Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9286 31.0711L59.8251 27.7251L62.2746 30.1746L58.9286 31.0711Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0714 16.9289L72.1749 20.2749L69.7254 17.8254L73.0714 16.9289Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.6171 55.0918C-25.6171 55.0918 31.8946 38.5872 86.092 71.4716C86.092 71.4716 78.1638 112.401 10.6586 90.3929C-22.55 79.5657 -25.6171 55.0918 -25.6171 55.0918Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9229 52.672C20.3822 51.596 18.6035 52.135 18.6035 52.135L18.5883 52.1464C17.9596 52.3104 17.4017 52.6755 17 53.1862L17.2666 59.0899H21.3801L21.5477 53.0853L21.9229 52.672Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2017 59.0973L17.9351 53.1936C17.9351 53.1936 19.649 50.8226 22.3933 53.0032C22.4231 53.0298 22.4511 53.0585 22.4771 53.0889L22.1095 59.0973H18.2017Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4718 53.7402H20.0356V56.1074H20.4718V53.7402Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0581 54.4639H19.4375V54.9H21.0581V54.4639Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 57.672C29.3822 56.596 27.6035 57.135 27.6035 57.135L27.5883 57.1464C26.9596 57.3104 26.4017 57.6755 26 58.1862L26.2666 64.0899H30.3801L30.5477 58.0853L30.9229 57.672Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2017 64.0973L26.9351 58.1936C26.9351 58.1936 28.649 55.8226 31.3933 58.0032C31.4231 58.0298 31.4511 58.0585 31.4771 58.0889L31.1095 64.0973H27.2017Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4718 58.7402H29.0356V61.1074H29.4718V58.7402Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0581 59.4639H28.4375V59.9H30.0581V59.4639Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8553 48.6628C10.3358 47.6016 8.58149 48.1331 8.58149 48.1331L8.56646 48.1444C7.94637 48.3061 7.39623 48.6663 7 49.1699L7.26296 54.9925H11.32L11.4853 49.0704L11.8553 48.6628Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18532 54.9999L7.92236 49.1773C7.92236 49.1773 9.61279 46.8389 12.3194 48.9895C12.3488 49.0158 12.3764 49.0441 12.402 49.074L12.0395 54.9999H8.18532Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.94774 75.3809C-5.94774 75.3809 46.4349 46.4664 106.601 66.4362C106.601 66.4362 108 108.103 37.2868 101.703C2.5 98.5544 -5.94774 75.3809 -5.94774 75.3809Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8497 70.9342C29.7578 68.0765 25.0337 69.5079 25.0337 69.5079L24.9932 69.5382C23.3234 69.9737 21.8419 70.9436 20.7749 72.2999L21.483 87.9796H32.4082L32.8533 72.0318L33.8497 70.9342Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9669 87.9998L23.2588 72.3201C23.2588 72.3201 27.811 66.0229 35.0995 71.8143C35.1787 71.8851 35.253 71.9611 35.322 72.0419L34.3458 87.9998H23.9669Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9952 73.7715H28.8369V80.0585H29.9952V73.7715Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5533 75.6943H27.249V76.8526H31.5533V75.6943Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7604 60.404C54.6685 57.5462 49.9443 58.9776 49.9443 58.9776L49.9039 59.008C48.234 59.4434 46.7526 60.4133 45.6855 61.7696L46.3937 77.4493H57.3189L57.764 61.5015L58.7604 60.404Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8775 77.4695L48.1694 61.7898C48.1694 61.7898 52.7216 55.4926 60.0101 61.284C60.0893 61.3548 60.1636 61.4309 60.2327 61.5116L59.2565 77.4695H48.8775Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.671 49.7848C80.5791 46.9271 75.855 48.3585 75.855 48.3585L75.8145 48.3888C74.1447 48.8243 72.6632 49.7942 71.5962 51.1505L72.3043 66.8302H83.2295L83.6746 50.8824L84.671 49.7848Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7882 66.8503L74.0801 51.1707C74.0801 51.1707 78.6322 44.8735 85.9208 50.6649C85.9999 50.7357 86.0743 50.8117 86.1433 50.8925L85.1671 66.8503H74.7882Z",
    fill: "#413D45"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRowGrave);
export default __webpack_public_path__ + "static/media/imgRowGrave.146facba0dd343258de1ba78a78acbe5.svg";
export { ForwardRef as ReactComponent };